<template>
  <a-card :bordered="false" title="短链列表" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="shortUrl"
      params-path="getShortUrlList"
      :customPagination="true"
      @changePageParameter="changePageParameter"
    >
      <span slot="action" slot-scope="rowItem">
          <a @click="editProject(rowItem)">编辑</a>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="是否要删除当前链接？"
            @confirm="delProject(rowItem)">
              <a>删除</a>
          </a-popconfirm>
        </span>
    </custom-page-table>

    <a-modal
      title="修改链接"
      :width="500"
      v-model="visibleLink"
      @cancel="visibleLink=false"
      :destroyOnClose='true'
      :footer="null"
    >
      <a-form @submit="searchBtn" :form="form">
        <a-form-item label="原链接地址" v-bind="customFormItemLayout">
          <a-input
            placeholder="请输入长链地址"
            autocomplete="off"
            v-decorator="['longUrl', { rules: [
                  { required: true, message: '请输入长网址', trigger: 'blur' },
                  { pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确的网络链接', trigger: 'blur'},
                  ] }]"
          ></a-input>
        </a-form-item>
        <a-button type="primary" style="margin-left:385px;" htmlType="submit">确定</a-button>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import userHelper from '@/utils/helper/userHelper'
import formMixins from '../../../../utils/mixins/formMixins'

export default {
  name: 'ShotLinkList',
  mixins: [formMixins],
  data() {
    return {
      columns: [
        {
          title: '短链接',
          dataIndex: 'surl'
        },
        {
          title: '原长链接',
          dataIndex: 'longUrl',
          width: '250px'
        },
        {
          title: '跳转次数',
          dataIndex: 'clickNum'
        },
        {
          title: '生成方式',
          dataIndex: 'createTypeStr'
        },
        {
          title: '有效期',
          dataIndex: 'expirationTypeStr'
        },
        {
          title: '创建时间',
          dataIndex: 'createDate'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {},
      visibleLink: false,
      customFormItemLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 15
        }
      },
      shortUrlLink: ''
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'GenerateLink', title: '短链服务' }, {
      name: 'ShotLinkList',
      title: '短链列表'
    }])
    this.changePageParameter()
  },
  mounted() {
  },
  methods: {
    changePageParameter() {
      this.queryParams = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        signMsg: new Date().getTime(),
        signValue: userHelper.md5('shortUrlSK' + new Date().getTime() + 'shortUrlSK')
      }
    },
    editProject(rowItem) {
      this.visibleLink = true
      this.shortUrlLink = rowItem.record.surl
    },
    delProject(rowItem) {
      this.queryParams.newLongUrl = ''
      this.queryParams.shortUrl = rowItem.record.surl
      this.queryParams.signMsg = new Date().getTime()
      this.queryParams.signValue = userHelper.md5('shortUrlSK' + new Date().getTime() + 'shortUrlSK')
      this.getHttpServices().getShortService().post('deleteShortUrl', this.queryParams)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    searchBtn(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.queryParams.newLongUrl = values.longUrl
          this.queryParams.shortUrl = this.shortUrlLink
          this.queryParams.signMsg = new Date().getTime()
          this.queryParams.signValue = userHelper.md5('shortUrlSK' + new Date().getTime() + 'shortUrlSK')
          this.getHttpServices().getShortService().post('updateLongUrl', this.queryParams)
            .then(res => {
              this.visibleLink = false
              this.$message.success('短链接更新成功')
              this.$refs.tableList.refresh(true)
            }).catch(reason => this.showNetWorkErrorMessage(reason))
        }
      })
    }
  }

}
</script>
<style scoped>
</style>